import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';

export default function Navbar({ onMenuClick, pageTitle, pageSubtitle }) {
  const { user } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();

  const badgeLabel = unreadCount > 99 ? '99+' : String(unreadCount);

  return (
    <header className="navbar">
      <button className="navbar-menu-btn" onClick={onMenuClick}>
        &#9776;
      </button>
      <div className="navbar-info">
        <h1 className="navbar-title">{pageTitle || 'Dashboard'}</h1>
        {pageSubtitle && <span className="navbar-subtitle">{pageSubtitle}</span>}
      </div>
      <div className="navbar-actions">
        <button
          className="navbar-notification"
          type="button"
          aria-label={
            unreadCount > 0
              ? `${unreadCount} unread notifications`
              : 'Notifications'
          }
          onClick={() => navigate('/notifications')}
        >
          <img src={`${process.env.PUBLIC_URL}/images/notification-bell.svg`} alt="" />
          {unreadCount > 0 && (
            <span className="navbar-notification-count">{badgeLabel}</span>
          )}
        </button>
        <div
          className="navbar-avatar"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/settings')}
        >
          <div className="navbar-avatar-placeholder">{user?.avatar}</div>
        </div>
      </div>
    </header>
  );
}
